import defaultOptions from './defaultoption'

const checkout = {
  async converterCotacaoNegociacaoEmPedido(body) {
    // var token = `${auth.token()}`
    // var tokendecoded = jwt.decode(token)

    return await fetch(
      `${process.env.REACT_APP_API_CHECKOUT}api/Pedido/ConvertePedido`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }
    )
  }
}

export default checkout
